import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef, useState } from "react";
import { OtpRegisterFormInterface } from "@/app/components/auth/Forms/OtpRegisterForm/OtpRegisterForm.interface";
import { DirectionRightIcon, EditIcon } from "@/app/components/UI/Icons";
import registerContent from "@/app/components/auth/registerContent";
import { p2e } from "@/app/utils/replaceNumber";
import maskPhoneNumber from "@/app/utils/maskPhoneNumber";
import { useTranslations } from "next-intl";
import cn from "@/app/utils/cn";
import { localeDirClient } from "@/app/utils/locale";
import VerificationCode from "@/app/components/UI/VerificationCode";
import VerificationCodeButton from "@/app/components/UI/VerificationCode/VerificationCodeButton";
export default function OtpRegisterForm(props) {
  const $ = _c(79);
  const t = useTranslations();
  const timerRef = useRef(null);
  const [otpCode, setOtpCode] = useState("");
  const [timerCompleted, setTimerCompleted] = useState(false);
  const [timerTarget, setTimerTarget] = useState(null);
  const [error, setError] = useState(false);
  const mobileRequestRef = useRef(false);
  const submittedCodeRef = useRef("");
  let t0;
  if ($[0] !== props.registerMobileResponse?.ttl) {
    t0 = () => {
      const ttl = props?.registerMobileResponse?.ttl;
      if (ttl) {
        const target = Date.now() + ttl * 1000;
        timerRef.current = target;
        setTimerTarget(target);
      }
    };
    $[0] = props.registerMobileResponse?.ttl;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = props?.registerMobileResponse?.ttl;
  let t2;
  if ($[2] !== t1) {
    t2 = [t1];
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t0, t2);
  let t3;
  if ($[4] !== otpCode || $[5] !== props) {
    t3 = function submitOtp(t4) {
      const allowResubmit = t4 === undefined ? false : t4;
      if (otpCode.length !== 6 || props.isMobilePending || props.isOtpPending || !allowResubmit && submittedCodeRef.current === otpCode) {
        return;
      }
      submittedCodeRef.current = otpCode;
      props.onVerifyOtp({
        code: otpCode,
        tracking_id: props.trackingId,
        mobile: props.mobile
      });
    };
    $[4] = otpCode;
    $[5] = props;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const submitOtp = t3;
  let t4;
  if ($[7] !== otpCode.length || $[8] !== submitOtp) {
    t4 = () => {
      if (otpCode.length === 6) {
        submitOtp();
      }
    };
    $[7] = otpCode.length;
    $[8] = submitOtp;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== otpCode || $[11] !== props.isMobilePending || $[12] !== props.isOtpPending) {
    t5 = [otpCode, props.isMobilePending, props.isOtpPending];
    $[10] = otpCode;
    $[11] = props.isMobilePending;
    $[12] = props.isOtpPending;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  useEffect(t4, t5);
  let t6;
  if ($[14] !== props) {
    t6 = async function resendOtp(e) {
      e.preventDefault();
      if (props.isMobilePending || mobileRequestRef.current) {
        return;
      }
      mobileRequestRef.current = true;
      submittedCodeRef.current = "";
      setError(false);
      setOtpCode("");
      props.onResendOtp("SMS");
      setTimerCompleted(false);
      const ttl_0 = props.registerMobileResponse?.ttl;
      if (ttl_0) {
        const target_0 = Date.now() + ttl_0 * 1000;
        timerRef.current = target_0;
        setTimerTarget(target_0);
      }
    };
    $[14] = props;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const resendOtp = t6;
  let t7;
  if ($[16] !== props) {
    t7 = async function switchOtpProvider(provider) {
      if (props.isMobilePending || mobileRequestRef.current) {
        return;
      }
      mobileRequestRef.current = true;
      submittedCodeRef.current = "";
      setError(false);
      setOtpCode("");
      props.onResendOtp(provider);
      setTimerCompleted(false);
      const ttl_1 = props.registerMobileResponse?.ttl;
      if (ttl_1) {
        const target_1 = Date.now() + ttl_1 * 1000;
        timerRef.current = target_1;
        setTimerTarget(target_1);
      }
    };
    $[16] = props;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const switchOtpProvider = t7;
  let t8;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = value => {
      setError(false);
      setOtpCode(p2e(value));
    };
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const handleOtp = t8;
  let t10;
  let t9;
  if ($[19] !== props.isOtpError) {
    t9 = () => {
      if (props.isOtpError) {
        setError(true);
      } else {
        setError(false);
      }
    };
    t10 = [props.isOtpError];
    $[19] = props.isOtpError;
    $[20] = t10;
    $[21] = t9;
  } else {
    t10 = $[20];
    t9 = $[21];
  }
  useEffect(t9, t10);
  let t11;
  let t12;
  if ($[22] !== props.isMobilePending) {
    t11 = () => {
      if (!props.isMobilePending) {
        mobileRequestRef.current = false;
      }
    };
    t12 = [props.isMobilePending];
    $[22] = props.isMobilePending;
    $[23] = t11;
    $[24] = t12;
  } else {
    t11 = $[23];
    t12 = $[24];
  }
  useEffect(t11, t12);
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = () => {
      submittedCodeRef.current = "";
      setError(false);
      setOtpCode("");
    };
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== props.mobile || $[27] !== props.trackingId) {
    t14 = [props.mobile, props.trackingId];
    $[26] = props.mobile;
    $[27] = props.trackingId;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  useEffect(t13, t14);
  let t15;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className={cn(localeDirClient() === "ltr" ? "rotate-180" : "")}><DirectionRightIcon className="w-6 h-6" /></div>;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== props.backFunc) {
    t16 = <div className="md:hidden"><div className="mt-20 cursor-pointer" onClick={props.backFunc}>{t15}</div></div>;
    $[30] = props.backFunc;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== props || $[33] !== t) {
    t17 = <div className="mt-6 mb-8">{props.provider !== "SMS" ? <><h1 className="text-base md:text-2xl font-bold">{t("auth.LOGIN_OTP_TITLE")}</h1><div className="md:flex items-center gap-x-2 mt-4"><p className="text-charcoal-600 text-sm">{t("auth.LOGIN_VIA_GA_TEXT")}</p><button type="button" className="flex items-center gap-x-1 mt-3 md:mt-0" onClick={e_0 => {
            e_0.preventDefault();
            props.setStep(0);
          }}><EditIcon className="w-6 h-6" /><p className="text-xs text-bluetiful-400 font-semibold">{t("auth.EDIT_MOBILE")}</p></button></div></> : <><h1 className="text-base md:text-2xl font-bold">{props.flow === "login" ? t("auth.LOGIN_OTP_TITLE") : t("auth.REGISTER_OTP_TITLE")}</h1><div className="md:flex items-center gap-x-2 mt-4"><p className="text-charcoal-600 text-sm">{t("auth.LOGIN_VIA_SMS_TEXT", {
              number: maskPhoneNumber(props.mobile)
            })}</p><button type="button" className="flex items-center gap-x-1 mt-3 md:mt-0" onClick={e_1 => {
            e_1.preventDefault();
            props.setStep(0);
          }}><EditIcon className="w-6 h-6" /><p className="text-xs text-bluetiful-400 font-semibold">{t("auth.EDIT_MOBILE")}</p></button></div></>}</div>;
    $[32] = props;
    $[33] = t;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t) {
    t18 = t(registerContent.OtpInputTitle);
    $[35] = t;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== error || $[38] !== props.otpErrorMessage || $[39] !== t) {
    t19 = error ? props.otpErrorMessage ?? t("auth.INVALID_OTP_CODE") : "";
    $[37] = error;
    $[38] = props.otpErrorMessage;
    $[39] = t;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== error || $[42] !== t19) {
    t20 = {
      hasError: error,
      message: t19
    };
    $[41] = error;
    $[42] = t19;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  const t21 = props.provider === "SMS";
  let t22;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = () => setTimerCompleted(true);
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] !== resendOtp || $[46] !== t21 || $[47] !== timerCompleted || $[48] !== timerTarget) {
    t23 = {
      visible: t21,
      target: timerTarget,
      completed: timerCompleted,
      onComplete: t22,
      onResend: resendOtp
    };
    $[45] = resendOtp;
    $[46] = t21;
    $[47] = timerCompleted;
    $[48] = timerTarget;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] !== props.isMobilePending || $[51] !== props.onNoAccess || $[52] !== props.provider || $[53] !== switchOtpProvider || $[54] !== t) {
    t24 = props.provider === "GA" && props.onNoAccess ? {
      label: t("security.TFA_NO_ACCESS"),
      onClick: props.onNoAccess,
      disabled: props.isMobilePending
    } : props.provider === "GA" ? {
      label: t("auth.CONTINUE_WITH_SMS"),
      onClick: () => switchOtpProvider("SMS"),
      disabled: props.isMobilePending
    } : undefined;
    $[50] = props.isMobilePending;
    $[51] = props.onNoAccess;
    $[52] = props.provider;
    $[53] = switchOtpProvider;
    $[54] = t;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== otpCode || $[57] !== t18 || $[58] !== t20 || $[59] !== t23 || $[60] !== t24) {
    t25 = <VerificationCode inputLabel={t18} value={otpCode} onChange={handleOtp} error={t20} timer={t23} secondaryAction={t24} />;
    $[56] = otpCode;
    $[57] = t18;
    $[58] = t20;
    $[59] = t23;
    $[60] = t24;
    $[61] = t25;
  } else {
    t25 = $[61];
  }
  let t26;
  if ($[62] !== props.isOtpError || $[63] !== submitOtp) {
    t26 = () => submitOtp(props.isOtpError);
    $[62] = props.isOtpError;
    $[63] = submitOtp;
    $[64] = t26;
  } else {
    t26 = $[64];
  }
  const t27 = timerCompleted || otpCode.length < 6;
  const t28 = props.isOtpPending;
  let t29;
  if ($[65] !== t) {
    t29 = t("auth.CONFIRM");
    $[65] = t;
    $[66] = t29;
  } else {
    t29 = $[66];
  }
  let t30;
  if ($[67] !== props.isOtpPending || $[68] !== t26 || $[69] !== t27 || $[70] !== t29) {
    t30 = <VerificationCodeButton onClick={t26} disabled={t27} loading={t28} className="w-full mt-4">{t29}</VerificationCodeButton>;
    $[67] = props.isOtpPending;
    $[68] = t26;
    $[69] = t27;
    $[70] = t29;
    $[71] = t30;
  } else {
    t30 = $[71];
  }
  let t31;
  if ($[72] !== t25 || $[73] !== t30) {
    t31 = <div className="relative my-10">{t25}{t30}</div>;
    $[72] = t25;
    $[73] = t30;
    $[74] = t31;
  } else {
    t31 = $[74];
  }
  let t32;
  if ($[75] !== t16 || $[76] !== t17 || $[77] !== t31) {
    t32 = <div className="">{t16}{t17}{t31}</div>;
    $[75] = t16;
    $[76] = t17;
    $[77] = t31;
    $[78] = t32;
  } else {
    t32 = $[78];
  }
  return t32;
}